const { getMaterials, createMaterial, updateMaterial, deleteMaterial, getStock, adjustStock, buildPriceTableMessage } = require('@/controllers/materials').ct_materials;

const initialState = () => ({
    materials: [],
    pagination: {},
    stock: { summary: {}, data: [] },
});

const state = initialState();

const mutations = {
    SET_MATERIALS(state, { data, pagination = {} }) {
        state.materials = data;
        state.pagination = pagination;
    },
    SET_STOCK(state, { summary = {}, data }) {
        state.stock = { summary, data };
    },
    RESET_MATERIALS_STATE(state) {
        Object.assign(state, initialState());
    },
};

const getters = {
    get_materials(state) {
        return state.materials;
    },
    get_materials_pagination(state) {
        return state.pagination;
    },
    get_stock(state) {
        return state.stock;
    },
};

const actions = {
    async load_materials({ commit }, params = {}) {
        const response = await getMaterials({ limit: 100, ...params });

        if (!response.status) {
            throw response.error;
        }

        commit('SET_MATERIALS', response);
        return response.data;
    },

    // payload: { id?, ...campos }. Com id atualiza (PUT), sem id cria (POST)
    async save_material(_, { id, ...data }) {
        const response = id ? await updateMaterial(id, data) : await createMaterial(data);

        if (!response.status) {
            throw response.error;
        }

        return response.data;
    },

    async remove_material(_, id) {
        const response = await deleteMaterial(id);

        if (!response.status) {
            throw response.error;
        }

        return response;
    },

    async load_stock({ commit }, params = {}) {
        const response = await getStock(params);

        if (!response.status) {
            throw response.error;
        }

        commit('SET_STOCK', response);
        return response;
    },

    // payload: { id, stock } ou { id, delta }, mais `reason` opcional
    async adjust_stock(_, { id, ...data }) {
        const response = await adjustStock(id, data);

        if (!response.status) {
            throw response.error;
        }

        return response.data;
    },

    // só monta o texto: a API não salva a tabela
    async build_price_message(_, payload) {
        const response = await buildPriceTableMessage(payload);

        if (!response.status) {
            throw response.error;
        }

        return response.data;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
